import { RadToDegV3 as o } from "./index20.js";
const t = (e) => o(e.toArray().slice(0, 3));
export {
  t as EulerToDegrees
};
//# sourceMappingURL=index6.js.map
